import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';

type CardVariants = 'default' | 'well' | 'well-darker';

// no-unused-vars: key is being used
const cardClasses: Record<CardVariants, string> = {
  default: 'bg-white shadow-sm',
  well: 'bg-gray-50',
  'well-darker': 'bg-gray-200',
};

type CardProps = {
  variant?: CardVariants;
} & ComponentPropsWithoutRef<'div'>;

const CardWrapper: FC<CardProps> = ({ children, className, variant = 'default' as CardVariants, ...otherProps }) => {
  return (
    <div className={cn('rounded-lg', cardClasses[variant], className ?? '')} {...otherProps}>
      {children}
    </div>
  );
};

type BodyType = { gray?: boolean } & ComponentPropsWithoutRef<'div'>;
const Body: FC<BodyType> = ({ gray, children, className, ...otherProps }) => (
  <div
    className={cn('border-t border-gray-200 px-4 py-5 sm:p-6', gray ? 'bg-gray-50' : '', className ?? '')}
    {...otherProps}
  >
    {children}
  </div>
);

type HeaderType = {
  right?: ReactNode;
} & ComponentPropsWithoutRef<'div'>;

const Header: FC<HeaderType> = ({ children, className, right, ...otherProps }) => (
  <div className={cn('px-4 py-5 sm:px-6', className ?? '')} {...otherProps}>
    <div className="-mt-2 -ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
      <div className="mt-2 ml-4 flex items-center">{children}</div>
      {!!right && <div className="mt-2 ml-4 shrink-0">{right}</div>}
    </div>
  </div>
);

type FooterType = { gray?: boolean } & ComponentPropsWithoutRef<'div'>;
const Footer: FC<FooterType> = ({ gray, children, className, ...otherProps }) => (
  <div
    className={cn('rounded-b-lg p-4 sm:px-6', gray ? 'bg-gray-50' : 'border-t border-gray-200', className ?? '')}
    {...otherProps}
  >
    {children}
  </div>
);

export const Card = Object.assign(CardWrapper, { Header, Body, Footer });
